import React from 'react'
import NavBar from './Navbar';
import CopyRight from './CopyRight';
import { Outlet } from "react-router-dom";
import ScrollToTopButton from './ScrollToTopButton';

const Layout = () => {
  return (
    <div className="min-h-screen bg-primary-bg">
      <NavBar />
      <main>
        <Outlet />
      </main>
      <ScrollToTopButton />
      <CopyRight />
    </div>
  )
}

export default Layout
